import PropTypes from 'prop-types';

const propTypes = {
  id: PropTypes.string.isRequired,
  content: PropTypes.string,
  name: PropTypes.string,
};

class Column {
  static propTypes = propTypes;
}

export default Column;
